import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.account.user.stateData.add;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'ACCOUNT_USER_STATEDATA_ADD',
	url: '/account/user/statedata/add.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
